(function() {
  if (window.__nalaClubInit) return;
  window.__nalaClubInit = true;

document.addEventListener('DOMContentLoaded', function() {

// Reveal on scroll + progress bar trigger
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('in');
        io.unobserve(e.target);
        // When the bar-wrap is revealed, animate the fill
        if(e.target.id === 'barwrap'){
          setTimeout(function(){
            var fill = document.getElementById('barFill');
            if(fill) fill.style.width = '78%';
          }, 300);
        }
      }
    });
  },{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

  // Animated counter
  document.querySelectorAll('[data-count]').forEach(el=>{
    const target = parseInt(el.dataset.count,10);
    const obs = new IntersectionObserver((ents)=>{
      ents.forEach(en=>{
        if(en.isIntersecting){
          const start = performance.now();
          const dur = 1800;
          function step(t){
            const p = Math.min((t-start)/dur,1);
            const eased = 1 - Math.pow(1-p,3);
            const v = Math.floor(target*eased);
            el.textContent = v.toLocaleString('ro-RO');
            if(p<1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          obs.disconnect();
        }
      });
    },{threshold:.5});
    obs.observe(el);
  });

}); // DOMContentLoaded

})(); // IIFE guard